import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { exposeEventToPartner } from '../../Helpers/events';

const AutoScrollWidgetRepositioning = () => {
  const [nextContainer, setNextContainer] = useState(undefined);
  const {
    isAutoScrollEnabled,
    isDynamicHeightEnabled,
    iFrameId,
    maximumWidgetHeight,
    minimumWidgetHeight,
  } = useSelector((store) => store.optionalFormConfig);
  const { requiredWidgetHeight } = useSelector((store) => store.dynamicHeight);
  const { currentPage } = useSelector((store) => store.navigation);
  const { enterPhase } = useSelector((store) => store.transition);

  useEffect(() => {
    /* NOTE: The React app will only ever see one next container as it lives within the iFrame and not at the parent page level.
     * It is the formLoader that lives at the parent page level and therefore at the cross-iFrame level.
     * That is where we must handle the multitude of iFrame widgets and not here.
     */
    if (!nextContainer && document) {
      setNextContainer(document?.getElementById('__next'));
    }
  });

  useEffect(() => {
    /*
     * Runs whenever the page has completed a nav transition (i.e. when the Transition ENTER phase completes by toggling to false).
     */
    const newWidgetHeight = nextContainer?.getBoundingClientRect().height;
    const currentWidgetHeight = requiredWidgetHeight;
    const wasAutoScrollInvokedByHelper =
      window.__private__?.pageAutoScrollInvocationTracker &&
      !!window.__private__?.pageAutoScrollInvocationTracker[currentPage];
    const { isLegalStatementMountingOrUnmounting } =
      window?.__private__?.dynamicWidgetHeightData || {};

    const wasWidgetResizeInitiated =
      // Any widget resize will schedule a follow-up autoScroll operation from within the formLoader, hence,
      // there is no need to re-invoke another autoScroll attempt from here
      currentWidgetHeight !== newWidgetHeight &&
      !(
        (currentWidgetHeight <= minimumWidgetHeight &&
          newWidgetHeight <= minimumWidgetHeight) ||
        (currentWidgetHeight >= maximumWidgetHeight &&
          newWidgetHeight >= maximumWidgetHeight)
      );
    const skipAutoScroll = isLegalStatementMountingOrUnmounting;
    if (
      isAutoScrollEnabled &&
      !skipAutoScroll &&
      !enterPhase &&
      (!isDynamicHeightEnabled ||
        (isDynamicHeightEnabled &&
          !wasAutoScrollInvokedByHelper &&
          !wasWidgetResizeInitiated))
    ) {
      const eventObject = {
        iFrameId,
      };
      if (
        !window.__private__ ||
        typeof window.__private__ !== 'object' ||
        Array.isArray(window.__private__)
      ) {
        window.__private__ = {};
      }
      window.__private__.pageAutoScrollInvocationTracker = {}; // tracks the latest page to have had autoScroll invoked against it
      window.__private__.pageAutoScrollInvocationTracker[currentPage] = true;

      exposeEventToPartner({
        eventType: 'invokeAutoScroll',
        eventObject,
      });
    }
    /**
     * enterPhase: a completed page transition means that enterPhase will change true -> false.
     */
  }, [enterPhase]);

  useEffect(() => {
    if (
      !window.__private__ ||
      typeof window.__private__ !== 'object' ||
      Array.isArray(window.__private__)
    ) {
      window.__private__ = {};
    }
    window.__private__.pageAutoScrollInvocationTracker = {};
    window.__private__.pageAutoScrollInvocationTracker[currentPage] = false;
  }, [currentPage]);

  return null;
};

export default AutoScrollWidgetRepositioning;
